export default __webpack_public_path__ + "static/2021-RI-22-03-30-77dc28405225909e6df11304bb612e64.pdf";